import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '@app/memberships/state/store';
import { generateFieldValidationRules } from '@app/helpers/memberships/fields';

export default function(validate, form){
    return {
        title     : 'Application details',
        component : rawDynamicImport(() => import('@app/memberships/components/form/stages/additional_details/AdditionalDetails.vue')),
        isValid   : computed(
            () => validate(
                generateFieldValidationRules(data.membership_type.details.value?.fields ?? [], data.answers.details.value ?? {})
            )
        ),
        data: computed(
            () => ({
                fields: form.value.fields
            })
        ),
        onReloadData : (progression) => {
            form.value.fields = progression.data.fields instanceof Object
                ? { ...form.value.fields,...progression.data.fields }
                : {}
        },
    }
}